/* ==========================================================================
   VERON · Geschenkgutschein – Produktseite (16.10.2026)
   --------------------------------------------------------------------------
   sections/veron-gutschein.liquid. Datenvertrag Theme ↔ Aussteller „Schema 1“
   (veron/catalog gutschein/SPEZIFIKATION.md Kap. 5):
     versteckt  properties[_gs_v]="1", [_gs_an]=ich|empfaenger, [_gs_email] (nur
                empfaenger), [_gs_von] (≤ 40), [_gs_fuer] (≤ 40), [_gs_text]
                (≤ 250, ≤ 5 Zeilen), [_gs_sprache] = request.locale.iso_code
     sichtbar   lokalisierte Schlüssel veron.gutschein.eig.* – nur Anzeige
   Leere Felder gehen nicht mit (disabled). Der Aussteller liest nur _gs_* und
   prüft alles nach (gutschein/pruefung.py – dieselben Fälle wie
   tests/gutschein/pruefung_faelle.json).
   Wunschbetrag → Variante über das Metafeld veron.gutschein_varianten (Liquid
   kennt höchstens 250 Varianten, das Produkt hat 496).
   In den Warenkorb wie VERON-SCHUBFACH (sections/veron-product.liquid): Ajax,
   Schubfach öffnen; ohne Schubfach/Fehler VOR dem Hinzufügen das normale
   Formular; nach erfolgreichem cart/add.js nie ein zweites Absenden.
   Ohne JavaScript: Betragsknöpfe sind echte Radiofelder name="id" (Varianten
   25–200 €), Von/Für/Text/Empfänger gehen direkt als _gs_* mit.
   ========================================================================== */
(function (wurzel, fabrik) {
  const api = fabrik();
  if (typeof window !== 'undefined') window.VeronGutschein = api;
  else if (typeof module === 'object' && module && module.exports) module.exports = api;   // node: tests/gutschein/
  else wurzel.VeronGutschein = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // summePruefung: ab dieser Gutscheinsumme je Bestellung haelt der Aussteller zur Pruefung an (gutschein/konfig.json
  // max_summe_je_bestellung, Spez. 7.3/F4b) - die Seite sagt das vorher (Hinweis, kein Verbot)
  const GRENZEN = { von: 40, fuer: 40, text: 250, zeilen: 5, email: 254, lokal: 64, betragMin: 5, betragMax: 500,
    mengeMin: 1, mengeMax: 10, summePruefung: 500 };
  // Gruss-Schriftgroessen der Karte in mm wie pdf.py _karte (4,6 -> 2,8)
  const GRUSS_GROESSEN = [4.6, 4.3, 4.0, 3.7, 3.4, 3.1, 2.8];
  const ERLAUBTE_ZEICHEN = new Set(['♥', '❤', '★', '☆', '✓']); // ♥ ❤ ★ ☆ ✓
  const ERLAUBTE_FORMAT = new Set(['‍', '‌', '️']);                    // ZWJ, ZWNJ, VS16
  const RX_SCHRIFT = /[\p{Script=Latin}\p{Script=Cyrillic}\p{Script=Greek}\p{Script=Common}\p{Script=Inherited}]/u;
  const RX_BILD = /\p{Extended_Pictographic}/u;
  const RX_BIDI = /[‪-‮⁦-⁩]/u;
  const RX_STEUER = /[\p{Cc}\p{Cf}\p{Co}\p{Cn}\p{Cs}]/u;
  const TLD = 'de|com|nl|net|org|eu|be|at|ch|info|biz|io|co|uk|pl|tr|ua|ru|al|xyz|online|shop|store|app|site|top|me|tv|cc|ly|gl|link|click|page|live|club|pro|fr|it|es|lu|dk|se|no|fi|cz|sk|hu|ro|bg|gr|pt|ie|us|ca|au|in|cn|jp|kr|br';
  // Links und E-Mail-Adressen (Schutz vor Phishing ueber unsere Absenderadresse, Spez. 5.2). Die Domain-Endung nur klein
  // geschrieben: „Danke.Es war schön“ (fehlendes Leerzeichen) ist kein Link, „veron-store.de“ schon.
  const RX_LINK_A = /(?:https?:\/\/|www\.|@)/i;
  const RX_LINK_B = new RegExp('(?:^|[^\\p{L}\\p{N}_-])[\\p{L}\\p{N}_-]+\\.(?:' + TLD + ')(?![\\p{L}\\p{N}])', 'u');
  const RX_LOKAL = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
  const RX_LABEL = /^(?!-)[a-z0-9-]{1,63}(?<!-)$/;

  /** NFC, Zeilenenden vereinheitlicht, Mehrfach-Leerraum je Zeile zusammengefasst, getrimmt. */
  function normalisieren(wert, mehrzeilig) {
    let s = String(wert == null ? '' : wert).normalize('NFC').replace(/\r\n?/g, '\n');
    if (!mehrzeilig) s = s.replace(/\n+/g, ' ');
    s = s.split('\n').map(function (z) { return z.replace(/[^\S\n]+/g, ' ').trim(); }).join('\n');
    if (mehrzeilig) s = s.replace(/\n{3,}/g, '\n\n');
    return s.trim();
  }

  function laenge(s) { return Array.from(s).length; }

  /** Zeichen erlaubt? (Spezifikation 5.2) */
  function zeichenFehler(s, mehrzeilig) {
    for (const z of s) {
      if (z === '\n') { if (mehrzeilig) continue; return 'zeichen'; }
      if (RX_BIDI.test(z)) return 'zeichen';
      if (ERLAUBTE_FORMAT.has(z)) continue;
      if (RX_STEUER.test(z)) return 'zeichen';
      if (ERLAUBTE_ZEICHEN.has(z)) continue;
      if (RX_BILD.test(z)) return 'zeichen';
      if (!RX_SCHRIFT.test(z)) return 'zeichen';
    }
    return null;
  }

  /** Von/Für/Text: -> {wert, fehler: null|'pflicht'|'laenge'|'zeilen'|'zeichen'|'link'} */
  function pruefeText(roh, art, pflicht) {
    const mehrzeilig = art === 'text';
    const wert = normalisieren(roh, mehrzeilig);
    if (!wert) return { wert: '', fehler: pflicht ? 'pflicht' : null };
    const zf = zeichenFehler(wert, mehrzeilig);
    if (zf) return { wert: wert, fehler: zf };
    if (RX_LINK_A.test(wert) || RX_LINK_B.test(wert)) return { wert: wert, fehler: 'link' };
    if (laenge(wert) > GRENZEN[art]) return { wert: wert, fehler: 'laenge', max: GRENZEN[art] };
    if (mehrzeilig && wert.split('\n').length > GRENZEN.zeilen) return { wert: wert, fehler: 'zeilen' };
    return { wert: wert, fehler: null };
  }

  /** Domain -> ASCII (Punycode) ueber URL, kleingeschrieben; null = ungueltig. */
  function domainAscii(domain) {
    try {
      const host = new URL('http://' + domain + '/').hostname.toLowerCase();
      if (!host || host.length > 253 || host.indexOf('.') < 0) return null;
      const teile = host.split('.');
      if (!teile.every(function (t) { return RX_LABEL.test(t); })) return null;
      if (!/^(?:[a-z]{2,63}|xn--[a-z0-9-]{1,59})$/.test(teile[teile.length - 1])) return null;
      return host;
    } catch (e) {
      return null;
    }
  }

  /** E-Mail: getrimmt, Domain kleingeschrieben (Unicode bleibt fuer die Anzeige). -> {wert, fehler} */
  function pruefeEmail(roh) {
    const s = String(roh == null ? '' : roh).normalize('NFC').trim();
    if (!s) return { wert: '', fehler: 'pflicht' };
    if (laenge(s) > GRENZEN.email || /\s/.test(s) || RX_STEUER.test(s) || RX_BIDI.test(s)) {
      return { wert: s, fehler: 'format' };
    }
    const at = s.split('@');
    if (at.length !== 2) return { wert: s, fehler: 'format' };
    const lokal = at[0], domain = at[1];
    if (!lokal || laenge(lokal) > GRENZEN.lokal || !RX_LOKAL.test(lokal)) return { wert: s, fehler: 'format' };
    if (/[:/?#[\]\\%]/.test(domain)) return { wert: s, fehler: 'format' };
    if (!domainAscii(domain)) return { wert: s, fehler: 'format' };
    return { wert: lokal + '@' + domain.toLowerCase(), fehler: null };
  }

  /** Wunschbetrag: ganze Euro 5..500 -> {wert:Number|null, fehler} */
  function pruefeBetrag(roh) {
    const s = String(roh == null ? '' : roh).trim().replace(/\s*€$/, '');
    if (!/^\d{1,3}$/.test(s)) return { wert: null, fehler: 'bereich' };
    const n = Number(s);
    if (n < GRENZEN.betragMin || n > GRENZEN.betragMax) return { wert: null, fehler: 'bereich' };
    return { wert: n, fehler: null };
  }

  /** Anzahl: ganze Zahl 1..10 (Tastatureingabe; das Formular hat novalidate) -> {wert:Number|null, fehler} */
  function pruefeMenge(roh) {
    const s = String(roh == null ? '' : roh).trim();
    if (!/^\d{1,2}$/.test(s)) return { wert: null, fehler: 'menge' };
    const n = Number(s);
    if (n < GRENZEN.mengeMin || n > GRENZEN.mengeMax) return { wert: null, fehler: 'menge' };
    return { wert: n, fehler: null };
  }

  /** Summe Betrag x Anzahl ueber der Pruefgrenze? (Aussteller haelt solche Bestellungen an) */
  function summeUeberGrenze(betrag, menge) {
    return Number(betrag) > 0 && Number(menge) > 0 && Number(betrag) * Number(menge) > GRENZEN.summePruefung;
  }

  /** Geldbetrag im Format des Shops (Muster aus Liquid: {{ 1234567 | money }} -> "12.345,67 €"). */
  function geldFormat(muster) {
    const m = /12(\D?)345(\D)67/.exec(muster || '');
    if (!m) return function (euro) { return euro + ' €'; };
    const tausend = m[1], dezimal = m[2];
    return function (euro) {
      const ganz = String(Math.floor(euro)).replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
      return muster.replace(m[0], ganz + dezimal + '00');
    };
  }

  /** Code in 4er-Gruppen ohne Leerzeichen-Zeichen (Kopieren liefert 16 Zeichen am Stueck, Spez. E10). */
  function codeGruppen(code) {
    return String(code || '').replace(/\s+/g, '').match(/.{1,4}/g) || [];
  }

  // Platzhalter __n__/__max__ (aus Liquid: 't: n: "__n__"' – ein '{{' im Liquid-Ausdruck braeche Shopifys Zerleger)
  function textMit(vorlage, werte) {
    return String(vorlage || '').replace(/__(\w+)__|\{\{\s*(\w+)\s*\}\}/g, function (_, a, b) {
      const n = a || b;
      return n in werte ? String(werte[n]) : '';
    });
  }

  /** HTML-Entitaeten aus Liquid-Texten loesen: Shopifys t-Filter escaped seine Ausgabe, | json behaelt "&#39;" -> ohne das
   *  stuende "euro&#39;s" in der Meldung (Befund A5 im echten Shopify, 16.10.2026). */
  function entschluesseln(s) {
    s = String(s == null ? '' : s);
    if (s.indexOf('&') < 0) return s;
    if (typeof document !== 'undefined' && document.createElement) {
      const t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }
    return s.replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(Number(n)); })
      .replace(/&#x([0-9a-f]+);/gi, function (_, n) { return String.fromCharCode(parseInt(n, 16)); })
      .replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }

  // ------------------------------------------------------------------ Seite
  function starte(wurzelEl) {
    if (!wurzelEl || wurzelEl.dataset.vgBereit) return;
    wurzelEl.dataset.vgBereit = '1';
    // Ohne Datenblock (Gutschein nicht verfuegbar, ?view=gutschein an einem anderen Produkt) gibt es kein Formular
    // (Befund Vorschau 16.10.2026: vorher TypeError, die Seite lief ohne Skript weiter)
    const datenEl = wurzelEl.querySelector('[data-vg-daten]');
    if (!datenEl) return;
    const daten = JSON.parse(datenEl.textContent);
    const T = {};
    Object.keys(daten.texte || {}).forEach(function (k) { T[k] = entschluesseln(daten.texte[k]); });
    const geld = geldFormat(daten.geld_muster);
    const karte = (daten.karte && daten.karte.varianten) || {};
    const form = wurzelEl.querySelector('form[data-vg-form]');
    if (!form) return;
    wurzelEl.classList.add('vg-js');

    const idFeld = form.querySelector('[data-vg-id]');
    const knoepfe = Array.from(form.querySelectorAll('[data-vg-betrag-knopf]'));
    const wunsch = form.querySelector('[data-vg-wunsch]');
    const anFelder = Array.from(form.querySelectorAll('[data-vg-an]'));
    const mailBlock = form.querySelector('[data-vg-mail-block]');
    const mail = form.querySelector('[data-vg-email]');
    const mail2 = form.querySelector('[data-vg-email2]');
    const von = form.querySelector('[data-vg-von]');
    const fuer = form.querySelector('[data-vg-fuer]');
    const text = form.querySelector('[data-vg-text]');
    const zaehler = form.querySelector('[data-vg-zaehler]');
    const menge = form.querySelector('[data-vg-menge]');
    const kauf = form.querySelector('[data-vg-kauf]');
    const zusammen = form.querySelector('[data-vg-zusammenfassung]');
    const korbFehler = form.querySelector('[data-vg-korb-fehler]');
    const preisEl = wurzelEl.querySelector('[data-vg-preis]');
    const pruefHinweis = form.querySelector('[data-vg-pruefung]');
    const vgPflichtVon = form.querySelector('[data-vg-pflicht-von]');
    const sichtbar = {
      versandart: form.querySelector('[data-vg-eig="versandart"]'),
      empfaenger: form.querySelector('[data-vg-eig="empfaenger"]'),
      von: form.querySelector('[data-vg-eig="von"]'),
      fuer: form.querySelector('[data-vg-eig="fuer"]'),
      text: form.querySelector('[data-vg-eig="text"]')
    };
    const versteckt = {
      an: form.querySelector('[data-vg-gs="an"]'),
      email: form.querySelector('[data-vg-gs="email"]'),
      von: form.querySelector('[data-vg-gs="von"]'),
      fuer: form.querySelector('[data-vg-gs="fuer"]'),
      text: form.querySelector('[data-vg-gs="text"]')
    };
    const vorschau = {
      karte: wurzelEl.querySelector('[data-vg-vorschau="karte"]'),
      linie: wurzelEl.querySelector('[data-vg-vorschau="linie"]'),
      person: wurzelEl.querySelector('[data-vg-vorschau="person"]'),
      betrag: wurzelEl.querySelector('[data-vg-vorschau="betrag"]'),
      fuer: wurzelEl.querySelector('[data-vg-vorschau="fuer"]'),
      von: wurzelEl.querySelector('[data-vg-vorschau="von"]'),
      fuerZeile: wurzelEl.querySelector('[data-vg-vorschau="fuer-zeile"]'),
      vonZeile: wurzelEl.querySelector('[data-vg-vorschau="von-zeile"]'),
      text: wurzelEl.querySelector('[data-vg-vorschau="text"]')
    };

    // Mit JavaScript traegt EIN verstecktes Feld die Variante; die Radiofelder (ohne JS name="id") verlieren den Namen,
    // die direkt benannten Eingabefelder ebenso (sie werden in die versteckten _gs_-Felder uebertragen).
    // Radiogruppen behalten einen (nicht uebertragenen) Namen, damit Pfeiltasten innerhalb der Gruppe wandern.
    knoepfe.forEach(function (k) { k.setAttribute('name', 'vg-betrag'); });
    [mail, mail2, von, fuer, text].forEach(function (f) { if (f) f.removeAttribute('name'); });
    anFelder.forEach(function (f) { f.setAttribute('name', 'vg-an'); });
    idFeld.disabled = false;

    let betrag = daten.vorauswahl;
    const angefasst = new Set();
    let versucht = false;

    function an() {
      const x = anFelder.find(function (f) { return f.checked; });
      return x ? x.value : 'ich';
    }

    function fehlerZeigen(feld, schluessel, max) {
      if (!feld) return;
      const box = form.querySelector('[data-vg-fehler-fuer="' + feld.id + '"]');
      const sichtbarMachen = versucht || angefasst.has(feld.id);
      const meldung = schluessel ? textMit(T['fehler_' + schluessel] || T.fehler_zeichen, { max: max || '' }) : '';
      if (box) {
        box.textContent = sichtbarMachen ? meldung : '';
        box.hidden = !(sichtbarMachen && meldung);
      }
      if (sichtbarMachen && meldung) feld.setAttribute('aria-invalid', 'true');
      else feld.removeAttribute('aria-invalid');
    }

    function betragSetzen(n, quelle) {
      betrag = n;
      knoepfe.forEach(function (k) {
        const aktiv = n !== null && Number(k.dataset.vgBetrag) === n;
        k.checked = aktiv;
        k.closest('.vg-betrag__knopf').classList.toggle('is-aktiv', aktiv);
      });
      if (quelle !== 'wunsch' && wunsch) wunsch.value = n === null ? '' : String(n);
      const vid = n === null ? null : karte[String(n)];
      if (vid) idFeld.value = String(vid);
      const text_ = n === null ? '' : geld(n);
      if (preisEl && n !== null) preisEl.textContent = text_;
      if (vorschau.betrag && n !== null) {
        // Betrag im Format der Sprache wie auf dem PDF (veron.gutschein.vorschau.betrag, z. B. "50 €", "€50", "€ 50")
        vorschau.betrag.textContent = T.vorschau_betrag ? textMit(T.vorschau_betrag, { betrag: n }) : String(n);
      }
    }

    function sammeln() {
      const f = {};
      const empf = an() === 'empfaenger';
      f.betrag = betrag !== null && karte[String(betrag)] ? null : 'bereich';
      if (wunsch && wunsch.value.trim() !== '' && pruefeBetrag(wunsch.value).fehler) f.betrag = 'bereich';
      const v = pruefeText(von && von.value, 'von', empf);
      const fu = pruefeText(fuer && fuer.value, 'fuer', false);
      const tx = pruefeText(text && text.value, 'text', false);
      let em = { wert: '', fehler: null }, em2 = null;
      if (empf) {
        em = pruefeEmail(mail && mail.value);
        if (!em.fehler) {
          const zweit = pruefeEmail(mail2 && mail2.value);
          if (zweit.fehler === 'pflicht') em2 = 'pflicht';
          else if (zweit.wert.toLowerCase() !== em.wert.toLowerCase()) em2 = 'gleich';
        } else if (mail2 && !mail2.value.trim()) {
          em2 = null;
        }
      }
      return { empf: empf, von: v, fuer: fu, text: tx, email: em, email2: em2, betragFehler: f.betrag };
    }

    function uebertragen(s) {
      // versteckte _gs_-Felder (Aussteller) und sichtbare Felder (Anzeige); leer -> disabled = geht nicht mit
      function setze(el, wert) {
        if (!el) return;
        el.value = wert || '';
        el.disabled = !wert;
      }
      setze(versteckt.an, s.empf ? 'empfaenger' : 'ich');
      setze(versteckt.email, s.empf ? s.email.wert : '');
      setze(versteckt.von, s.von.fehler ? '' : s.von.wert);
      setze(versteckt.fuer, s.fuer.fehler ? '' : s.fuer.wert);
      setze(versteckt.text, s.text.fehler ? '' : s.text.wert);
      setze(sichtbar.versandart, T.eig_versandart_wert);
      setze(sichtbar.empfaenger, s.empf ? s.email.wert : T.eig_ich);
      setze(sichtbar.von, s.von.fehler ? '' : s.von.wert);
      setze(sichtbar.fuer, s.fuer.fehler ? '' : s.fuer.wert);
      setze(sichtbar.text, s.text.fehler ? '' : s.text.wert);
    }

    function vorschauZeigen(s) {
      if (vorschau.fuer) vorschau.fuer.textContent = s.fuer.wert;
      if (vorschau.fuerZeile) vorschau.fuerZeile.hidden = !s.fuer.wert;
      if (vorschau.von) vorschau.von.textContent = s.von.wert;
      if (vorschau.vonZeile) vorschau.vonZeile.hidden = !s.von.wert;
      if (vorschau.text) vorschau.text.textContent = s.text.wert;
      // Linie wie im PDF nur, wenn Für/Von/Gruß da sind
      if (vorschau.linie) vorschau.linie.hidden = !(s.fuer.wert || s.von.wert || s.text.wert);
      grussEinpassen();
    }

    // Gruß wie pdf.py: größte Schrift (4,6 … 2,8 mm), bei der alles über dem Codefeld Platz hat
    function grussEinpassen() {
      if (!vorschau.karte || !vorschau.person || !vorschau.text) return;
      for (const g of GRUSS_GROESSEN) {
        vorschau.karte.style.setProperty('--vk-g', String(g));
        if (vorschau.person.scrollHeight <= vorschau.person.clientHeight + 1) break;
      }
    }

    function pruefen() {
      const s = sammeln();
      if (mailBlock) mailBlock.hidden = !s.empf;
      form.querySelectorAll('.vg-an-hinweis').forEach(function (h) {
        h.hidden = !h.classList.contains('vg-an-hinweis--' + (s.empf ? 'empfaenger' : 'ich'));
      });
      if (vgPflichtVon) vgPflichtVon.hidden = !s.empf;
      if (von) {
        if (s.empf) von.setAttribute('aria-required', 'true');
        else von.removeAttribute('aria-required');
      }
      fehlerZeigen(wunsch, s.betragFehler);
      const mg = pruefeMenge(menge && menge.value);
      fehlerZeigen(menge, mg.fehler);
      if (pruefHinweis) pruefHinweis.hidden = !summeUeberGrenze(s.betragFehler ? 0 : betrag, mg.wert || 0);
      fehlerZeigen(von, s.von.fehler, s.von.max);
      fehlerZeigen(fuer, s.fuer.fehler, s.fuer.max);
      fehlerZeigen(text, s.text.fehler, s.text.max);
      fehlerZeigen(mail, s.empf ? (s.email.fehler === 'format' ? 'format' : s.email.fehler) : null);
      fehlerZeigen(mail2, s.empf ? s.email2 : null);
      if (zaehler && text) {
        const n = laenge(normalisieren(text.value, true));
        zaehler.textContent = textMit(T.zaehler, { n: n, max: GRENZEN.text });
        zaehler.classList.toggle('is-voll', n > GRENZEN.text);
      }
      vorschauZeigen(s);
      uebertragen(s);
      const ok = !s.betragFehler && !mg.fehler && !s.von.fehler && !s.fuer.fehler && !s.text.fehler &&
        (!s.empf || (!s.email.fehler && !s.email2));
      kauf.setAttribute('aria-disabled', ok ? 'false' : 'true');
      if (ok && zusammen) zusammen.hidden = true;
      return ok;
    }

    knoepfe.forEach(function (k) {
      k.addEventListener('change', function () {
        if (k.checked) { betragSetzen(Number(k.dataset.vgBetrag), 'knopf'); angefasst.delete(wunsch && wunsch.id); pruefen(); }
      });
    });
    if (wunsch) {
      wunsch.addEventListener('input', function () {
        const p = pruefeBetrag(wunsch.value);
        betragSetzen(p.fehler ? null : p.wert, 'wunsch');
        pruefen();
      });
      wunsch.addEventListener('blur', function () { angefasst.add(wunsch.id); pruefen(); });
    }
    anFelder.forEach(function (f) { f.addEventListener('change', pruefen); });
    [mail, mail2, von, fuer, text].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', pruefen);
      f.addEventListener('blur', function () { angefasst.add(f.id); pruefen(); });
    });
    form.querySelectorAll('[data-vg-menge-schritt]').forEach(function (b) {
      b.addEventListener('click', function () {
        const n = Math.max(GRENZEN.mengeMin, Math.min(GRENZEN.mengeMax, (parseInt(menge.value, 10) || 1) + Number(b.dataset.vgMengeSchritt)));
        menge.value = String(n);
        angefasst.add(menge.id);
        pruefen();
      });
    });
    if (menge) {
      menge.addEventListener('input', pruefen);
      menge.addEventListener('blur', function () { angefasst.add(menge.id); pruefen(); });
    }

    // ── VERON-SCHUBFACH wie sections/veron-product.liquid (nie doppelt) ──
    const korbSeite = daten.korb_url || '/cart';
    let legtGerade = false;
    form.addEventListener('submit', function (e) {
      versucht = true;
      if (!pruefen()) {
        e.preventDefault();
        if (zusammen) { zusammen.hidden = false; }
        const erstes = form.querySelector('[aria-invalid="true"]');
        if (erstes) erstes.focus();
        else if (zusammen) zusammen.focus();
        return;
      }
      const schubfach = document.getElementById('cart-drawer');
      if (!schubfach || typeof schubfach.open !== 'function' || !window.fetch || !window.FormData) return;
      e.preventDefault();
      if (legtGerade) return;
      legtGerade = true;
      kauf.setAttribute('aria-busy', 'true');
      if (korbFehler) korbFehler.hidden = true;
      const basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const fd = new FormData(form);
      fd.delete('vg-betrag');
      fd.delete('vg-an');
      fd.append('sections', 'cart-drawer-section');
      fd.append('sections_url', window.location.pathname);
      const stueck = Number(fd.get('quantity')) || 1;
      let abgelehnt = false, hinzugefuegt = false;
      fetch(basis + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { abgelehnt = true; throw new Error('abgelehnt'); } return j; }); })
        .then(function (j) {
          hinzugefuegt = true;
          return fetch(basis + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (korb) { return { abschnitte: j.sections || null, korb: korb }; });
        })
        .then(function (x) {
          if (!x.korb || typeof x.korb.item_count !== 'number') throw new Error('korb');
          const ergebnis = { cart: { totalQuantity: x.korb.item_count }, detail: { sections: x.abschnitte, itemCount: stueck, didError: false, source: 'veron-gutschein' } };
          const ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          ev.action = 'add';
          ev.context = 'product';
          ev.lines = [{ merchandiseId: String(idFeld.value), quantity: stueck }];
          ev.promise = Promise.resolve(ergebnis);
          form.dispatchEvent(ev);
          ev.promise.then(function () { setTimeout(function () { schubfach.open(); }, 0); });
          document.documentElement.setAttribute('data-veron-schubfach', 'geoeffnet');
        })
        .catch(function () {
          if (abgelehnt) { if (korbFehler) korbFehler.hidden = false; return; }
          if (hinzugefuegt) { window.location.assign(korbSeite); return; }
          HTMLFormElement.prototype.submit.call(form);
        })
        .finally(function () { legtGerade = false; kauf.removeAttribute('aria-busy'); });
    });

    betragSetzen(betrag, 'start');
    pruefen();
  }

  function alleStarten() {
    document.querySelectorAll('[data-vg-seite]').forEach(function (el) {
      try { starte(el); } catch (e) { if (window.console) console.error('VeronGutschein', e); }
    });
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleStarten);
    else alleStarten();
  }

  return { GRENZEN: GRENZEN, normalisieren: normalisieren, pruefeText: pruefeText, pruefeEmail: pruefeEmail,
           pruefeBetrag: pruefeBetrag, pruefeMenge: pruefeMenge, summeUeberGrenze: summeUeberGrenze,
           geldFormat: geldFormat, codeGruppen: codeGruppen, domainAscii: domainAscii, entschluesseln: entschluesseln,
           starte: starte };
});
